import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { sportEndPoint } from "../../../constant/Environment";
import { getAllReport } from "../../../Utility/API";
import ResultSearch from "../../../components/FilterComponent/ResultSearch";
import Loader from "../../../components/Loader";


function getNumberOfPages(rowCount, rowsPerPage) {
  return Math.ceil(rowCount / rowsPerPage);
}

function toPages(pages) {
  const results = [];
  for (let i = 1; i <= pages; i++) {
    results.push(i);
  }

  return results;
}

const columns = [

  {
    name: "Event Date",
    selector: (row) => row.Event_Date,
    sortable: true,
  },
  {
    name: "Event Description",
    selector: (row) => row.Event_Description,
    sortable: true,
  },
  {
    name: "Event Type",
    selector: (row) => row.Event_Type,
    sortable: true,
  },
  {
    name: "Selection",
    selector: (row) => row.Selection,
    sortable: true,
  },
  {
    name: "Issuance Time",
    selector: (row) => row.Issuance_Date_And_Time,
    sortable: true,
  },
  {
    name: "Transaction Time",
    selector: (row) => row.Transaction_Time,
    sortable: true,
  },
  {
    name: "Bet Amount ($)",
    selector: (row) => row.Bet_Amount,
    sortable: true,
  },
  {
    name: "Paid Amount ($)",
    selector: (row) => row.Cancelled_Bet_Amount,
    sortable: true,
  },
  {
    name: "Account Designation",
    selector: (row) => row.Account_Designation,
    sortable: true,
  },
  {
    name: "Account Number",
    selector: (row) => row.Account_Number,
    sortable: true,
  },
  {
    name: "Bet Description",
    selector: (row) => row.Bet_Description,
    sortable: true,
  },
  {
    name: "Bet ID",
    selector: (row) => row.Bet_ID,
    sortable: true,
  },
  {
    name: "System Identifier",
    selector: (row) => row.System_Identifier,
    sortable: true,
  }


];
// RDT exposes the following internal pagination properties
const BootyPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage, // available but not used here
  currentPage
}) => {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    <nav>
      <ul className="pagination">
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            Previous
          </button>
        </li>
        {pageItems.map((page) => {

          const className =
            page === currentPage ? "page-item active" : "page-item";

          return (
            <li key={page} className={className}>
              <button
                className="page-link"
                onClick={handlePageNumber}
                value={page}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

const CancelledBets = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoadinig] = useState(false);
  const [filterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const filteredItems = rows.filter(
    (item) =>
      item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  );



  useEffect(() => {
    var body = {
      "code": "",
      "platform": "",
      "status": "cancelled",
      "fromDate": "",
      "toDate": "",
      "market": "",
      "tournament": "",
      "sport": "",
      "type": "LIST",
      "period": "1m"
    }
    fetchBetData(body);
  }, []);

  const fetchBetData = async (body) => {

    let url = `${sportEndPoint.apiBaseUrl + sportEndPoint.api.REPORT}`;

    await getAllReport(url, body)
      .then((response) => {
        console.log("data", response);
        if (response) {
          setRows(response);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className="main">

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: '0px' }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-2">Cancelled Bets</h2>
                </div>
              </div>
              <div
                className="row"
                style={{ padding: "5px 0px 20px 0px" }}
              >
                <div className="col-md-12">
                  <ResultSearch report="cancelled" searchBetData={fetchBetData} />
                </div>

              </div>
              <div className="container-fluid table-custom">
                <div
                  className="row"
                  style={{ padding: "5px 0px 20px 0px" }}
                >

                  <div className="col-md-12">
                    <DataTable
                      title=""
                      columns={columns}
                      data={rows}
                      defaultSortFieldID={1}
                      pagination
                      paginationComponent={BootyPagination}
                      paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                    // subHeader
                    // subHeaderComponent={subHeaderComponentMemo}
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancelledBets;
